export function saveProgressLabel(saving, reloading) {
  if (saving === true) {
    return "Saving...";
  }
  if (reloading === true) {
    return "Reloading...";
  }
  return "";
}
